import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingState } from '../../models/component-events.model';

@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="loading-overlay" *ngIf="shouldShow">
      <div class="loading-content">
        <div class="rfqLoader"></div>
        <div class="loading-text" *ngIf="message">
          {{ message }}
        </div>
      </div>
    </div>
  `,
  styles: [`
    .loading-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.85);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999999;
    }

    .loading-content {
      text-align: center;
    }

    .rfqLoader {
      width: 50px;
      aspect-ratio: 1;
      display: grid;
      color: #2E58D6;
      background: radial-gradient(farthest-side, currentColor calc(100% - 6px), #0000 calc(100% - 5px) 0);
      -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 13px), #000 calc(100% - 12px));
      border-radius: 50%;
      animation: l19 3s infinite linear;
      margin: 0 auto 16px;
    }

    .rfqLoader::before,
    .rfqLoader::after {
      content: "";
      grid-area: 1/1;
      background:
        linear-gradient(currentColor 0 0) center,
        linear-gradient(currentColor 0 0) center;
      background-size: 100% 10px, 10px 100%;
      background-repeat: no-repeat;
    }

    .rfqLoader::after {
      transform: rotate(45deg);
    }

    @keyframes l19 {
      100% {
        transform: rotate(1turn)
      }
    }

    .loading-text {
      color: #6c757d;
      font-size: 1rem;
      font-weight: 500;
    }
  `]
})
export class LoadingOverlayComponent {
  @Input() isLoading: boolean = false;
  @Input() loadingMessage: string = '';
  @Input() contactId?: number; // Added for future functionality like PDF downloads
  @Input() loadingState?: LoadingState | null;

  get shouldShow(): boolean {
    return this.isLoading || (this.loadingState?.isLoading ?? false);
  }

  get message(): string {
    return this.loadingMessage || this.loadingState?.loadingMessage || 'Loading...';
  }
}